import BaseSyncError from "scripts/exceptions/baseSyncError";

class UnsentSyncError extends BaseSyncError {}

export default UnsentSyncError;
